import React from "react";
import { Card, Progress, Typography } from "antd";
import { useTranslation } from "react-i18next";

const { Paragraph, Title } = Typography;

const ApplyProgress = ({ processed, total }) => {
  const { t } = useTranslation();
  const percent = total > 0 ? Math.round((processed / total) * 100) : 0;

  return (
    <Card>
      <div style={{ textAlign: "center", padding: "32px 0" }}>
        <Title level={4}>{t("price_import.apply.title")}</Title>
        <Paragraph type="secondary">{t("price_import.apply.description")}</Paragraph>
        <Progress type="circle" percent={percent} />
        <Paragraph style={{ marginTop: 16 }}>{t("price_import.apply.progress", { processed, total })}</Paragraph>
      </div>
    </Card>
  );
};

export default ApplyProgress;
